import { ChangeDetectionStrategy, Component, computed, EventEmitter, input, Output } from '@angular/core';
import { IconSvgObject } from '@hugeicons/angular';

export type BadgeColor = 'white' | 'brand' | 'error' | 'warning' | 'success' | 'orange' | 'blue' | 'critical' | 'dark';

export type BadgeSizes = 's' | 'm' | 'l';

@Component({
  selector: 'ptl-base-badge',
  templateUrl: './badge-base.component.html',
  styleUrls: ['./badge-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeBaseComponent {
  color = input<BadgeColor>('white');
  size = input<BadgeSizes>('m');
  disabled = input<boolean>(false);
  highlighted = input<boolean>(false);
  text = input<string>();
  icon = input<IconSvgObject>();
  iconSuffix = input<IconSvgObject>();
  ariaLabel = input<string>();

  @Output() clicked = new EventEmitter<void>();

  isIconOnly = computed(() => !this.text() && (!!this.icon() || !!this.iconSuffix()));

  onClick(): void {
    if (!this.disabled()) {
      this.clicked.emit();
    }
  }
}
